module.exports = __webpack_public_path__ + "img/2_banner.a559a5f9.png";